export { default as AvoidSoftInputView } from './AvoidSoftInputViewCompat';
//# sourceMappingURL=AvoidSoftInputView.web.js.map